import { render, staticRenderFns } from "./roulette.vue?vue&type=template&id=e2c0b9f6"
import script from "./roulette.vue?vue&type=script&lang=js"
export * from "./roulette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports